import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App, AlertController, ToastController } from 'ionic-angular';
import { Seva } from '../../models/Seva';
import { ExportToCSV } from '../../models/ExportToCSV';
import { TableReport } from '../../models/TableReport';
import { RestProvider } from '../../providers/rest/rest';
import { DatePipe } from '@angular/common';
import { Japa } from '../../models/japa';
import { JapaReportInput } from '../../models/japareportinput';

/**
 * Generated class for the ReportsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
})
export class ReportsPage {
  start_date = new Date().toISOString();
  end_date = new Date().toISOString();

  seva_array: Seva[] = [];
  exporter = new ExportToCSV();
  TablePopulated:boolean = false;
  DataArray:any;
  CashArray:any;
  ChequeArray:any;
  CardArray:any;
  TableDataForDisplay:TableReport[];
  RowTotal:number = 0;
  
  //new design variables
  reciept_no:string;
  voucher_no:string;
  date:any;
  fromdate:any;
  todate:any;
  today:any;
  nextday:Date;
  nextdaystr:any;
  selectOptions:any;
  category_array:any;
  seva:any;
  category:any;
  seva_id:number;
  showsevas:boolean = false;
  showCategories:boolean = false;
  japas_array:Japa[] = [];
  showjapas:boolean = false;
  japa:any;
  japa_id:number;
  japafromdate:any;
  japatodate:any;
  


  constructor(public navCtrl: NavController, public navParams: NavParams, private restProvider: RestProvider, public appCtrl: App, private alertController:AlertController, private datePipe: DatePipe, private toastCtrl:ToastController) {
  }
  ngOnInit() {
    this.selectOptions = {
      cssClass: 'remove-ok'
    };
    

    // this.category_array = ["REGULAR","BUILDING FUND","ARADHANE","PRATISHTAPANA","VOUCHERS","SUMMARY"];
    this.category_array = ["REGULAR","BUILDING FUND","ARADHANE","SILVER JUBILEE","VOUCHERS","SUMMARY"];
    this.category = this.category_array[0];
    this.DataArray = [];
    this.CashArray = [];
    this.CardArray = [];
    this.ChequeArray = [];
    this.TableDataForDisplay = [];
    this.TablePopulated = false;
    console.log(this.start_date);
    //new design varaiables
    this.today = new Date().toISOString().substring(0,10);
    this.nextday = new Date();
    this.nextday = new Date(this.nextday.setDate(this.nextday.getDate()+1));
    this.nextdaystr = this.nextday.toISOString().substring(0,10);
    //console.log("nextday",this.nextdaystr);
    console.log(this.date)
    this.fromdate = new Date().toISOString();
    this.fromdate = this.datePipe.transform(this.fromdate, "yyyy-MM-dd");
    this.todate = new Date().toISOString();
    this.todate = this.datePipe.transform(this.todate, "yyyy-MM-dd");
    this.japafromdate = new Date().toISOString();
    this.japafromdate = this.datePipe.transform(this.japafromdate, "yyyy-MM-dd");
    this.japatodate = new Date().toISOString();
    this.japatodate = this.datePipe.transform(this.japatodate, "yyyy-MM-dd");
    this.getSevasOfTheDay();
    this.getActiveJapas();
       //this.fromdate = new Date().toISOString();
       //this.todate = new Date().toISOString();
    
  }

  // onKeyPress(event) {
  //   //if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
  //     if (event.charCode == 189) {
  //       return true
  //   }
  //   else {
  //       return false
  //   }
  // }
  //FINDING AND PRINTING RECIEPT
  FindAndPrintReciept()
  {
    if(this.reciept_no == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter reciept number',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
if((this.reciept_no.trim()).length < 5 || (this.reciept_no.trim()).length > 5)
{
  let alert = this.alertController.create({
    title: 'Alert',
    subTitle: 'Please enter the last 5 digits of the reciept number to search',
   buttons: ['OK'],
    // enableBackdropDismiss: false // <- Here! :)
  });
 
  alert.present();
  return;
}
    this.restProvider.reprintPDF(this.reciept_no).subscribe(
      (res) => {

        console.log('res', res);
        var fileURL = URL.createObjectURL(res);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
        this.reciept_no = null;
      },
      error => {
        console.log(error);
        if(error.status == 404)
        {
          let alert = this.alertController.create({
            title: 'Alert',
            subTitle: 'Result not found.Please enter valid number',
            cssClass: 'buttonCss',
            buttons: [
              {
                text: 'Ok',
                cssClass: 'buttonCss',
                role: 'cancel',
                handler: () => {
                }
              }
            ]
          });
  
          alert.present();
  
          return
        }
        

      }
      
    );
  }

    //FINDING AND PRINTING RECIEPT
    FindAndPrintVoucher()
    {
      if(this.voucher_no == null)
      {
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Please enter voucher number',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
  if((this.voucher_no.trim()).length < 5 || (this.voucher_no.trim()).length > 5)
  {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Please enter the last 5 digits of the voucher number to search',
     buttons: ['OK'],
      // enableBackdropDismiss: false // <- Here! :)
    });
   
    alert.present();
    return;
  }
      this.restProvider.reprintVoucherPDF(this.voucher_no).subscribe(
        (res) => {
  
          console.log('res', res);
          var fileURL = URL.createObjectURL(res);
          console.log(fileURL)
          //this.ClearAllFields();
          window.open(fileURL);
          this.voucher_no = null;
        },
        error => {
          console.log(error);
          if(error.status == 404)
          {
            let alert = this.alertController.create({
              title: 'Alert',
              subTitle: 'Result not found.Please enter valid number',
              cssClass: 'buttonCss',
              buttons: [
                {
                  text: 'Ok',
                  cssClass: 'buttonCss',
                  role: 'cancel',
                  handler: () => {
                  }
                }
              ]
            });
    
            alert.present();
    
            return
          }
          
  
        }
        
      );
    }
  //DATE CHANGE
  DateChanged(){
    console.log("date inside datechanged event",this.date)
    this.getSevasOfTheDay();
  }

  //SHOW SEVA
  showSeva(){
    this.showsevas = !this.showsevas;
    console.log("inside show seva ", this.showsevas)
    
  }

  //SETTING SELECTED SEVA
  setSeva(s:Seva){
    console.log("seva passed from html",s)
  if(s){
    this.seva = s.sevaname;
   
  }
  this.showsevas = false;
  }
  
  //SHOW SEVA
  showCategory(){
      this.showCategories = !this.showCategories;
      console.log("inside show c ", this.showCategories)
      
    }
    
  //SETTING SELECTED SEVA
  setCategory(c){
      console.log("seva passed from html",c)
    if(c){
      this.category = c;
     
    }
    this.showCategories = false;
    }

  closecategorylist(){
      this.showCategories = false;
    }




  closesevalist(e){
    console.log("event",e.target.classList)
    if(!e.target.classList.contains('button')){
      console.log("came here")
      this.showsevas = false;
    }
    console.log("inside close fn")
    
  }
  //generating specific day report
  generateDaySevaReport()
  {
    if(this.date == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the date',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    var findsevarow = this.seva_array.find((item) => {return item.sevaname == this.seva})
     if(findsevarow){
       this.seva_id = findsevarow.id;
     }
     console.log("seva_id",this.seva_id);
    let reportdate = this.datePipe.transform(this.date,'yyyy-MM-dd');
    console.log("reportsevadate: and seva id before posting ",reportdate,this.seva_id)
    this.restProvider.reprintDaySevaReport(reportdate,this.seva_id).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  //showing financial total summary
  ShowFinancialSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }
  //showing financial seva summary
  ShowFinancialSevaSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
    this.restProvider.reprintFinancialSevaSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }
  ShowFinancialBuildingSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialBuildingSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  ShowFinancialAradhaneSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialAradhaneSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  ShowFinancialVouchersSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialVouchersSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  ShowFinancialPratishtapanaSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialPratishtapanaSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  ShowFinancialSilverJubileeSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialSilverJubileeSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  ShowFinancialAllSummary()
  {
    if(this.fromdate == null || this.todate == null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the  2 dates',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reportsevadate: ",todate);
    this.restProvider.reprintFinancialAllSummary(fromdate,todate).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

  OnGenerateReciept() {
this.TableDataForDisplay= [];
this.RowTotal = 0;

    // this.exporter.exportAllToCSV(this.seva_array, "SevaCSV");
    var strStartDate = this.start_date.slice(0.10);
    var strEndDate = this.end_date.slice(0.10);
    console.log("Target dates ", strStartDate, strEndDate, this.end_date);
    this.restProvider.getDailyReport(strStartDate, strEndDate)
    .subscribe(
      (res) => {

        console.log('res', res);
        this.TablePopulated = true;
        // var fileURL = URL.createObjectURL(res);
        // console.log(fileURL)
        // window.open(fileURL);
         this.CashArray = res.cash;
         this.CardArray = res.card;
         this.ChequeArray = res.cheque;

         let datearray:any;
         datearray = [];
         // let x = new TableReport;

         for (var d = new Date(this.start_date); d <= new Date(this.end_date); d.setDate(d.getDate() + 1))
         {

          let temp_date = this.datePipe.transform(d, "yyyy-MM-dd");
          console.log("Date after converting to required format",temp_date)
           //finding cash data for dates in dateArray
           let cash_data = this.CashArray.find((item)=> item.bookingdate == temp_date)
           console.log("matching cashdata",cash_data)
           //finding card data
           let card_data = this.CardArray.find((item)=> item.bookingdate == temp_date)
           console.log("matching carddata",card_data)
           let cheque_data = this.ChequeArray.find((item)=> item.bookingdate == temp_date)
           console.log("matching chequedata",cheque_data)

           datearray.push(temp_date);
         console.log(datearray.length)
         let x = new TableReport;
         x.b_date = temp_date;
         x.cash_amount = (cash_data)?cash_data.amount:0;
         x.card_amount = (card_data)?card_data.amount:0;
         x.cheque_amount = (cheque_data)?cheque_data.amount:0;
         this.TableDataForDisplay.push(x);

      }
       console.log("Dates Array",datearray)
       console.log("Table data:",this.TableDataForDisplay)
      



      },
      error => {
         console.log(error);
      }
    );

  }
  getRowSum(a:number,b:number,c:number)
  {
    
   this.RowTotal = a+b+c;
   return this.RowTotal;
  }

  //RETRIEVING SEVAS OF A DAY
  getSevasOfTheDay(){
    if(!this.date){
      this.date = new Date();
    this.date = this.datePipe.transform(this.date, "yyyy-MM-dd");
    }
    var formated_date = this.datePipe.transform(this.date, "yyyy-MM-dd");
    this.seva_array = [];
    console.log("date before passing",this.date);
    this.restProvider.getSevasOfTheDay(formated_date).subscribe(
      (result:any) => {
        console.log("sevas of the day from the API",result);
        this.seva_array = result;
        //I am pushing hardcoded string ALL to the result array
        var newrow = new Seva();
        newrow.sevaname = "ALL";
        newrow.id = 0;
        this.seva_array.splice(0,0,newrow)
        this.seva = this.seva_array[0].sevaname;
       },
      error => {
        console.log("error from API",error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    )
  }

  //CSV FOR SEVA REPORT
  generateDaySevaCSV(){
    let fromdate = this.datePipe.transform(this.date,'yyyy-MM-dd');
    console.log("reportsfromsevadate: ",fromdate);
   this.restProvider.csvReport(fromdate,fromdate,this.seva_id).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.date,'dd-MMM-yyyy');
      let filename:string = 'Seva-' +x+'.csv';
      console.log("filename",filename)
      if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
      
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )

  }

  //DEPENDING ON THE DROPDOWN SELECTION I AM CALLING THE API
  generateFinancePDF(){
    console.log("category before calling API:",this.category);
    if(this.category == 'REGULAR'){
      this.ShowFinancialSevaSummary();
    }
     if(this.category == 'BUILDING FUND'){
      this.ShowFinancialBuildingSummary();
    }
    if(this.category == 'ARADHANE'){
      this.ShowFinancialAradhaneSummary();
    }
    if(this.category == 'VOUCHERS'){
      this.ShowFinancialVouchersSummary();
    }
    if(this.category == 'SUMMARY'){
      this.ShowFinancialAllSummary();
    }
    if(this.category == 'PRATISHTAPANA'){
      this.ShowFinancialPratishtapanaSummary();
    }
    if(this.category == 'SILVER JUBILEE'){
      this.ShowFinancialSilverJubileeSummary();
    }
  }

  //GENERATING FINANCE CSV
  generateFinanceCSV(){
    console.log("category before calling API:",this.category);
    if(this.category == 'REGULAR'){
      this.generateFinanceSevaCSV();
    }
     if(this.category == 'BUILDING FUND'){
      this.generateFinanceBuildingCSV();
    }
    if(this.category == 'ARADHANE'){
      this.generateFinanceAradhaneCSV();
    }
    if(this.category == 'VOUCHERS'){
      this.generateFinanceVouchersCSV();
    }
    if(this.category == 'PRATISHTAPANA'){
      this.generateFinancePratishtapanaCSV();
    }
    
  }
//GENERATING FINANCE REGULR CSV
generateFinanceSevaCSV(){
  let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
  this.restProvider.financialRegularcsvReport(fromdate,todate).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.fromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.todate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'FinanceRegular-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
      
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}

//GENERATING FINANCE REGULR CSV
generateFinanceBuildingCSV(){
  let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
  this.restProvider.financialBuildingcsvReport(fromdate,todate).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.fromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.todate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'FinanceBuilding-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}

//GENERATING FINANCE REGULR CSV
generateFinanceAradhaneCSV(){
  let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
  this.restProvider.financialAradhanecsvReport(fromdate,todate).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.fromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.todate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'FinanceAradhane-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}

//GENERATING FINANCE REGULR CSV
generateFinanceVouchersCSV(){
  let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
  this.restProvider.financialVoucherscsvReport(fromdate,todate).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.fromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.todate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'FinanceVouchers-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.length > 0){
        this.exporter.exportAllToCSV(result, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}

//GENERATING FINANCE REGULR CSV
generateFinancePratishtapanaCSV(){
  let fromdate = this.datePipe.transform(this.fromdate,'yyyy-MM-dd');
    console.log("reportsfromevadate: ",fromdate);
    let todate = this.datePipe.transform(this.todate,'yyyy-MM-dd');
    console.log("reporttosevadate: ",todate);
  this.restProvider.financialPratishtapanacsvReport(fromdate,todate).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.fromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.todate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'FinancePratishtapana-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.length > 0){
        this.exporter.exportAllToCSV(result, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}
generaterecurringsevas(){
  this.restProvider.getrecurringsevabookings().subscribe(
    (result) => {
console.log("result",result);
let alert = this.alertController.create({
  title: 'Alert',
  subTitle: 'Seva bookings added - ' +result,
  enableBackdropDismiss:false,
  cssClass: 'buttonCss',
  buttons: [
    {
      text: 'Ok',
      cssClass: 'buttonCss',
      role: 'cancel',
      handler: () => {
      }
    }
  ]
});

alert.present();

return;

    },
    error => {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}

//get active japas
getActiveJapas(){
  this.restProvider.ShowAllActiveJapas().subscribe(
    (result) => {
      console.log("result", result);
      this.japas_array = result;
      var alljapa = {} as Japa;
      alljapa.japa_name = "ALL";
      alljapa.is_active = 1;
      alljapa.id = null;
      this.japas_array.splice(0,0,alljapa);
      console.log("japas array after adding ALL row",this.japas_array);
      this.japa = this.japas_array[0].japa_name;
    },
    error => {
      console.log("error from getactivejapas", error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get the japas,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

     

    }

  )
}
 //SHOW SEVA
 showJapa(){
  this.showjapas = !this.showjapas;
  console.log("inside show japa ", this.showjapas)
  
}

//SETTING SELECTED SEVA
setJapa(j:Japa){
  console.log("japa passed from html",j)
if(j){
  this.japa = j.japa_name;
 
}
this.showjapas = false;
}

  //generating specific day report
  generateDayJapaReport()
  {
    if(this.japafromdate == null && this.japatodate ==  null)
    {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the date',
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    var findjaparow = this.japas_array.find((item) => {return item.japa_name == this.japa})
     if(findjaparow){
       this.japa_id = findjaparow.id;
     }
     console.log("japa_id",this.japa_id);
    let reportdate1 = this.datePipe.transform(this.japafromdate,'yyyy-MM-dd');
    let reportdate2 = this.datePipe.transform(this.japatodate,'yyyy-MM-dd');
    var japareport = {} as JapaReportInput;
    japareport.fromdate = reportdate1;
    japareport.todate = reportdate2;
    japareport.japa_id = this.japa_id;
    japareport.report_type = "pdf";
    console.log("reportinput before posting ",japareport)
    this.restProvider.reprintDayJapaReport(japareport).subscribe(
      (result) => {
        console.log('res', result);
        if(result)
        {
          let toast = this.toastCtrl.create({
            message: 'Please wait for a couple of minutes..',
            duration: 3000,
            position:'middle'
          });
          toast.present();
        }
        var fileURL = URL.createObjectURL(result);
        console.log(fileURL)
        //this.ClearAllFields();
        window.open(fileURL);
      },
      error => {
        console.log(error);
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Could not get,please try again',
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return;
      }
    );
  }

 //GENERATING FINANCE REGULR CSV
generateDayJapaCSV(){
  if(this.japafromdate == null && this.japatodate ==  null)
  {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Please enter the date',
      cssClass: 'buttonCss',
      buttons: [
        {
          text: 'Ok',
          cssClass: 'buttonCss',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    alert.present();

    return
  }
  var findjaparow = this.japas_array.find((item) => {return item.japa_name == this.japa})
   if(findjaparow){
     this.japa_id = findjaparow.id;
   }
   console.log("japa_id",this.japa_id);
  let reportdate1 = this.datePipe.transform(this.japafromdate,'yyyy-MM-dd');
  let reportdate2 = this.datePipe.transform(this.japatodate,'yyyy-MM-dd');
  var japareport = {} as JapaReportInput;
  japareport.fromdate = reportdate1;
  japareport.todate = reportdate2;
  japareport.japa_id = this.japa_id;
  japareport.report_type = "csv";
  console.log("reportinput before posting ",japareport)
  this.restProvider.reprintDayJapaCSV(japareport).subscribe(
    (result) => {
      console.log("result",result);
      let x = this.datePipe.transform(this.japafromdate,'dd-MMM-yyyy');
      let y = this.datePipe.transform(this.japatodate,'dd-MMM-yyyy');
      console.log("fromdateseva,todateseva",x,y)
      let filename:string = 'Japa-' +x + '-' +y +'.csv';
      console.log("filename",filename)
      if(result.data.length > 0){
        this.exporter.exportAllToCSV(result.data, filename);
      }
      else{
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Empty Data Found',
          enableBackdropDismiss:false,
          cssClass: 'buttonCss',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });
  
        alert.present();
  
        return;
      }
      
    },
    error => {
      console.log("error",error);
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Could not get,please try again',
        enableBackdropDismiss:false,
        cssClass: 'buttonCss',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return;
    }
  )
}   
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts